import { Skeleton, TableBody, TableCell, TableRow } from '@mui/material';
import React, { FC } from 'react';

interface TableBodyLoaderProps {
  rowsPerPage: number;
  colSpan: number;
  height?: number | string;
  width?: number | string;
  tableCellPadding?: number | string;
}

const TableBodyLoader: FC<TableBodyLoaderProps> = ({
  colSpan,
  rowsPerPage,
  height,
  width,
  tableCellPadding = 'default',
}) => {
  return (
    <TableBody>
      {Array.from({ length: rowsPerPage }).map((_, i) => (
        <TableRow key={i}>
          {Array.from({ length: colSpan }).map((_, i) => (
            <TableCell key={i} sx={{ padding: tableCellPadding }}>
              <Skeleton variant='rounded' width={width} height={height} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};
export default TableBodyLoader;
